import styled from 'styled-components'
import { TooltipProps } from '@elamajs/ui-kit'

type StyledDotProps = {
  color: string
}

export const Container = styled.div`
  margin-right: 53px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 999px) {
    margin-right: 0;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    row-gap: 10px;
  }
`

export const Element = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`

export const Text = styled.span`
  color: #667399;
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;

  @media (max-width: 767px) {
    font-size: 14px;
  }
`

export const Dot = styled.div<StyledDotProps>`
  width: 3px;
  height: 20px;
  border-radius: 5px;
  background-color: ${({ color }) => color};
`

export const Tooltip = styled.div<TooltipProps>`
  color: #667399;

  ~ div > div {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;

    color: #667399;
  }
`
